export default {
  BASE_URL: '/admin/cms/million/company',
  api: [
    {
      name: 'list',
      desc: '获取列表',
      method: 'GET',
      path: '/list'
    },
    {
      name: 'detail',
      desc: '获取详情',
      method: 'GET',
      path: '/detail'
    },
    {
      name: 'add',
      desc: '新增',
      method: 'POST',
      path: '/insert'
    },
    {
      name: 'edit',
      desc: '编辑',
      method: 'POST',
      path: '/edit'
    },
    {
      name: 'delete',
      desc: '删除',
      method: 'POST',
      path: '/delete'
    },
    {
      name: 'import',
      desc: '导入',
      method: 'POST',
      path: '/importData'
    },
    {
      name: 'download',
      desc: '下载模板',
      method: 'GET',
      path: '/downloadTemplate'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/api/millionsProject/enterprises.js